import { useState, useCallback } from "react";

const SOUND_SETTINGS_KEY = "chatSoundSettings";

const DEFAULT_SETTINGS = {
  replySound: true,
  mentionSound: true,
  joinSound: false,
};

export default function useChatSoundNotifications(viewerId) {
  const [settings, setSettings] = useState(() => {
    try {
      const saved = localStorage.getItem(SOUND_SETTINGS_KEY);
      return saved ? JSON.parse(saved) : DEFAULT_SETTINGS;
    } catch {
      return DEFAULT_SETTINGS;
    }
  });

  const updateSettings = useCallback(
    (newSettings) => {
      const updated = { ...settings, ...newSettings };
      setSettings(updated);
      localStorage.setItem(SOUND_SETTINGS_KEY, JSON.stringify(updated));
    },
    [settings]
  );

  const playSound = useCallback(
    (type) => {
      console.log("[ChatSound] playSound called", {
        type,
        setting: settings[`${type}Sound`],
      });
      if (!settings[`${type}Sound`]) return;

      const audio = new Audio(`/sounds/notification-${type}.wav`);
      audio.volume = 0.1;
      audio.play().catch((err) => {
        console.log("[ChatSound] play blocked", err.message);
      });
    },
    [settings]
  );

  const handleNewMessage = useCallback(
    (message) => {
      console.log("[ChatSound] handleNewMessage", {
        message,
        viewerId,
        userId: message?.userId,
        replyToMessage: message?.replyToMessage,
        mentionUserId: message?.mentionUserId,
      });
      if (!message || message.userId === viewerId) {
        console.log("[ChatSound] skipped: own message or null");
        return;
      }

      if (
        message.messageType === "SYSTEM" &&
        message.systemEventType === "USER_JOINED"
      ) {
        playSound("join");
        return;
      }

      if (message.mentionUserId === viewerId) {
        playSound("mention");
        return;
      }

      if (message.replyToMessage?.userId === viewerId) {
        console.log("[ChatSound] reply match!", {
          replyUserId: message.replyToMessage.userId,
          viewerId,
        });
        playSound("reply");
        return;
      }

      console.log("[ChatSound] no sound condition matched");
    },
    [viewerId, playSound]
  );

  return { settings, updateSettings, handleNewMessage };
}
